import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Modal, Stack} from 'rsuite';
import SkillViewerNav from "./SkillViewerNav";
import BasicGrid from "../../grid/BasicGrid";

const defaultColumns = [
    {
        key: 'skillName',
        label: 'Name',
    },
];

const viewerModalGridStyle = {
    alignItems: 'baseline',
    display: 'grid',
    gridTemplateColumns: '25em 1fr'
};

const rightColumnStyle = {
    position: 'sticky',
    top: 0,
    paddingRight: '0.5em',
};

const SkillViewerModal = (props) => {
    const { open, handleClose, unformattedSkills } = props;

    const [bucketedSkills, setBucketedSkills] = useState({});
    const [active, setActive] = useState(undefined);
    // force table to rerender once modal is open
    // this stops the not full width issue on first load
    const [entered, setEntered] = useState(false);

    useEffect(() => {
        const skillBuckets = {}
        for (let i = 0; i < unformattedSkills.length; i++) {
            if (skillBuckets[unformattedSkills[i].skillType] === undefined) {
                skillBuckets[unformattedSkills[i].skillType] = [];
            }
            skillBuckets[unformattedSkills[i].skillType].push({skillName: unformattedSkills[i].skillName});
        }

        setBucketedSkills(skillBuckets);
        setActive(Object.keys(skillBuckets).sort()[0]);
    }, [unformattedSkills]);

    const localClose = useCallback(() => {
        handleClose();
    }, [handleClose]);

    return useMemo(() => {
            return (
                <Modal
                    open={open}
                    onEntered={() => {
                        setEntered(true);
                    }}
                    onExited={() => {
                        setEntered(false);
                    }}
                    onClose={() => localClose()}
                    backdrop="static"
                    size="full"
                >
                    <Modal.Header>
                        <Modal.Title>All Skills</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Stack spacing={2} direction='column' alignItems='flex-start' style={{paddingBottom: '0.5rem'}}>
                            <p>
                                These are all the skills currently tracked by this tool. They are organized by Skill Type.
                            </p>
                        </Stack>
                        <div style={viewerModalGridStyle}>
                            <SkillViewerNav appearance="tabs" bucketedSkills={bucketedSkills} active={active} onSelect={setActive} />
                            <div style={rightColumnStyle}>
                                <BasicGrid
                                    columns={defaultColumns}
                                    data={bucketedSkills[active]}
                                    handleClick={() => {}} // noop
                                    loading={!entered}
                                />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            );
        },
        [
            active,
            bucketedSkills,
            entered,
            localClose,
            open,
        ]
    );
}

export default SkillViewerModal;